// Credit Control is linked when the company has the Credit Control app and the project has not
// opted out of it. Once linked, Credit Control relays its loan amount into `bookings.loan_amount`
// through bms-api, so the booking row (not the Loan Tracker bank case) holds the current value.
export const isCreditControlLinked = (appConfig, project) => !!(
  appConfig && appConfig.data && appConfig.data.creditControlIsEnabled &&
  !(project && project.creditControlIsUnlinked)
);

// Without Credit Control nothing ever syncs the booking's loan amount after it is marked Sold, so
// the LI-issued bank case in Loan Tracker stays the live value and should still override it.
export const bankCaseOverridesLoanAmount = (appConfig, project) => (
  !isCreditControlLinked(appConfig, project)
);



// WEBPACK FOOTER //
// ./src/utils/creditControl.js